import { invoke } from '@shared/easyfy.decorators';
import { element, globalEvent } from '@shared/easyfy.core';
import { GetProductOption } from '../services/productoptions.service';
import { SnackBar, SnackbarSeverity } from './snackbar';
import MessageService from '@clientWebServices/message.service';

@invoke
export class OptionSelector {
  constructor() {
    globalEvent({
      type: 'click',
      events: [
        {
          action: 'select-variant',
          callback: this.selectVariant.bind(this),
        },
        {
          action: 'select-subscription-freq',
          callback: this.selectFrequency.bind(this),
        },
        {
          event: 'select-subscription-packsize',
          callback: this.selectSalesUnit.bind(this),
        },
        {
          action: 'update-frequency',
          callback: this.updateFrequency.bind(this),
        },
      ],
    });
  }

  onInit() {
    if (window.location.hash) {
      this.getSelectedOption(window.location.hash.replace('#', ''));
    }
    return false;
  }

  selectVariant = (e: Event) => {
    const selectedOptionEl = e.target as HTMLElement;
    const selectedOptionId = selectedOptionEl.dataset['optionId'];

    if (!selectedOptionId) return false;

    this.getSelectedOption(selectedOptionId);
    return false;
  };

  private getSelectedSalesUnitCode() {
    const productPageSelectorContainer = document.querySelector('[data-container="pdp-selector"]');
    const selectedSalesUnitCodeEl = productPageSelectorContainer?.querySelector('[data-container="salesunit-option"][data-selected]') as HTMLElement;
    return selectedSalesUnitCodeEl?.attributes?.['data-salesunitcode']?.value;
  }

  private getSelectedOption = (selectedOptionId: string) => {
    const selectedSalesUnitCode = this.getSelectedSalesUnitCode();

    GetProductOption(selectedOptionId, selectedSalesUnitCode)
      .then((response) => this.updateProductPageWithSelectedOption(response))
      .catch((error) => {
        console.log(error);
        MessageService.Instance.displayDefaultErrorMessage();
      });
  };

  private updateProductPageWithSelectedOption = (response: any) => {
    if (response?.data == null || !response?.data?.success) {
      if (response?.data?.errorMessage) {
        SnackBar.appendSnackbar(SnackbarSeverity.error, response.data.errorMessage);
      }
      return false;
    }

    const prodContainerEl = element('[data-container="product"]') as HTMLElement;
    const prodRecommendationsEl = element('[data-container="related-products"]') as HTMLElement;
    const prodContainerHtml = response?.data?.partialHtmlProdContainer;
    const prodRecommendationsHtml = response?.data?.partialHtmlProdRecommendations;

    if (prodContainerEl != null && prodContainerHtml != null) {
      prodContainerEl.innerHTML = prodContainerHtml;

      if (prodRecommendationsEl != null && prodRecommendationsHtml != null) {
        prodRecommendationsEl.innerHTML = prodRecommendationsHtml;
        const updateProdListEvt = new Event('component-productlistupdate', { bubbles: true, cancelable: false });
        document.dispatchEvent(updateProdListEvt);
      }

      const initializeProductImagesSlider = new Event('initialize-product-images-slider', { bubbles: true, cancelable: false });
      document.dispatchEvent(initializeProductImagesSlider);

      document.body.classList.remove('noof');
    }

    if (response.data?.searchProductId) {
      window.location.hash = response.data.searchProductId;
    }
  };

  private selectFrequency = (e: Event) => {
    this.updateSubscriptionData(e, ['optionid', 'optioninterval']);
    return false;
  };

  private selectSalesUnit = (e: Event) => {
    this.updateSubscriptionData(e, ['salesunitcode']);
    return false;
  };

  private updateSubscriptionData(e: Event, dataKeys: string[]) {
    const optionEl = e.target as HTMLElement;
    const parentEl = optionEl?.closest('[data-container="subscription-selector"]') as HTMLElement;

    if (!this.updateSelectedAttr(optionEl, parentEl)) return false;

    this.updateButtonsData(optionEl, parentEl, dataKeys);

    return false;
  }

  private updateSelectedAttr(el: HTMLElement, parentEl: HTMLElement): boolean {
    if (el?.hasAttribute('data-selected')) return false;

    const selected = parentEl?.querySelector('[data-selected]');
    selected?.removeAttribute('data-selected');
    el.setAttribute('data-selected', '');
    return true;
  }

  private updateButtonsData(el: HTMLElement, parentEl: HTMLElement, dataKeys: string[]) {
    const flyoutEl = parentEl.closest('.options-selector');
    const button = flyoutEl?.querySelector('[data-container="update-button"') as HTMLButtonElement;
    const addToCartBtn = flyoutEl?.querySelector('[data-action="add-to-cart"]');

    const newInterval: string = el?.dataset?.optioninterval;
    if (button) this.checkEnableButton(button, newInterval);

    dataKeys.forEach((dataKey) => {
      const selectedOptionDataValue = el?.dataset[dataKey];
      if (selectedOptionDataValue) {
        if (addToCartBtn) addToCartBtn?.setAttribute('data-' + dataKey, selectedOptionDataValue);
        else if (button) button?.setAttribute('data-' + dataKey, selectedOptionDataValue);
      }
    });
  }

  private checkEnableButton = (button: HTMLButtonElement, newInterval: string) => {
    const el = document.querySelector('[data-originally-selected]') as HTMLElement;

    if (el && button) {
      const originalInterval = el.dataset.optioninterval;
      button.disabled = originalInterval === newInterval;
    }
  };

  private updateFrequency = (e: Event) => {
    const el = e.target as HTMLElement;
    const selectedOptionInterval = el?.dataset?.optioninterval;
    const selectedOptionId = el?.dataset?.optionid;

    const frequencyFlyout = el?.closest('[data-container="frequency-selector"]');
    const productFlyout = frequencyFlyout?.closest('[data-subscription-flyout]');

    const selectedOption = frequencyFlyout?.querySelector('.option[data-selected]')?.querySelector(':scope > span') as HTMLElement;
    const selectedOptionIntervalName = selectedOption?.innerText;

    const addToCartBtn = productFlyout?.querySelector('[data-action="add-to-cart"]');
    const selectedFrequency = productFlyout?.querySelector('.option.selected-freq-option');

    if (selectedOptionInterval) {
      addToCartBtn?.setAttribute('data-optioninterval', selectedOptionInterval);
    }
    if (selectedOptionId) {
      addToCartBtn?.setAttribute('data-optionid', selectedOptionId);
      selectedFrequency?.setAttribute('data-optionid', selectedOptionId);
    }
    if (selectedOptionIntervalName) {
      const freq = selectedFrequency?.querySelector(':scope >span') as HTMLElement;
      freq.innerText = selectedOptionIntervalName;
    }
    const flyoutCloseBtn = element('[data-target="frequency-selector"]') as HTMLElement;
    flyoutCloseBtn?.click();
  };
}
